export enum Degree {
  FINAL = 'Egzamin maturalny',
  BACHELOR = 'Inżynier',
  MASTER = 'Magister',
  DOCTOR = 'Doktor',
}

export enum LangType {
  FRONTEND = 'Frontend',
  BACKEND = 'Backend',
  DATABASE = 'Database',
}

export enum ProjectType {
  NONPROFIT = 'Non Profit',
  QUIZZES = 'Quizzes',
  PERSONAL = 'Personal',
  MINOR = 'Minor',
}
